import type { Bootstrap, Member, Preferences } from '@obv/api-client';
import type { Orientation } from '@obv/ui';
import type { ZonedParts } from '@obv/core';
import { createContext, useContext } from 'react';

export interface DisplayCtx {
  boot: Bootstrap;
  prefs: Preferences;
  tz: string;
  clock: ZonedParts & { now: Date };
  orientation: Orientation;
  /** Phone-sized screen: widgets stack in one scrolling column and the nav moves to the bottom. */
  phone: boolean;
  membersById: Record<string, Member>;
  online: boolean;
  /** Nav rail tucked away (auto-hide menu); the home screen also drops its header. */
  chromeHidden: boolean;
  showChrome: () => void;
}

export const DisplayContext = createContext<DisplayCtx | null>(null);

export function useDisplay(): DisplayCtx {
  const ctx = useContext(DisplayContext);
  if (!ctx) throw new Error('useDisplay outside DisplayContext');
  return ctx;
}

export function memberLabel(ctx: DisplayCtx, memberId: string | null): { name: string; initial: string; colorKey: string | null } {
  if (!memberId) return { name: 'Family', initial: 'F', colorKey: null };
  const m = ctx.membersById[memberId];
  return m ? { name: m.display_name, initial: m.initial, colorKey: m.color_key } : { name: 'Someone', initial: '?', colorKey: null };
}
